// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".session-grid[data-v-3bd66d5c]{display:grid;grid-template-columns:4rem 24.8% 15% 20% auto auto;grid-column-gap:1.5rem}", ""]);
// Exports
module.exports = exports;
